module.exports = __webpack_public_path__ + "static/img/busca candidatos 768x1024.8c580f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/empleador/candidatos/busca candidatos 768x1024.jpg
// module id = VSJn
// module chunks = 47